<template lang="pug">
  .history-temporaryStock
    .form-section
      .history-container
        .history-label(:class="color") Version
        div {{ dataOriginal.version }}
      .history-container
        .history-label(:class="color") {{ capitalize(dataOriginal.transaction) }}d by
        shNameUser(v-if="dataOriginal.transaction === 'create'" :dni="dataOriginal.createdBy")
        shNameUser(v-else :dni="dataOriginal.updatedBy")
      .history-container(v-if="dataOriginal.stringStock")
        .history-label StringStock
        div {{ dataOriginal.stringStock }}
      .history-container(v-if="dataOriginal.stringExistsTiers")
        .history-label String Exists Tiers
        div {{ dataOriginal.stringExistsTiers }}
      .history-container(v-if="dataOriginal.stringExistsProducts")
        .history-label String Exists Products
        div {{ dataOriginal.stringExistsProducts }}
      .history-container(v-if="dataOriginal.stringExistsSizes")
        .history-label String Exists Sizes
        div {{ dataOriginal.stringExistsSizes }}
</template>

<script>
import mFilters from '@/mixins/filters'
import shNameUser from '@/components/elements/NameUser'

export default {
  name: 'HistoryTemporaryStock',

  mixins: [mFilters],

  components: { shNameUser },

  props: {
    dataOriginal: Object,
    color: String
  }
}
</script>

<style lang="stylus">
.history-temporaryStock
  position relative
  margin 1.4em 0 1.8em 0
</style>



// WEBPACK FOOTER //
// src/components/pages/temporaryStock/History.vue